export default __webpack_public_path__ + "images/BV.54f46b3.png";